import { useEffect } from "react";
import { useSelector } from 'react-redux';



import "./style.css";
import DocumentSheduleBody from "../../Components/DocumentSheduleBody";
import ContentContainer from "../../Components/ContentContainer/ContentContainer.js";
import SaveStatus from "../../UIComponents/SaveStatus";

import mapStateToProps from './mapStateToProps.js'
import { Typography } from "@mui/material";


const DocumentShedule = () => {


    const {
        documentData,
        rights,
        getDocumentData=()=>{},
        setDocumentData=()=>{},
    } = useSelector(mapStateToProps)
    // const rightCheker = (dir, right) => {
    //     const nt = `dir${dir.substring(0, 1).toUpperCase()}${dir.substring(1)}`;
    //     return !!(rights?.[`${nt}-${right}`])
    // }
    const {data:documents=[]} = documentData || {};

    const mapedDocuments=documents?.map((item=[])=>{
        const {
            id,
            number, 
            date,
            company,
            project,
            periodFrom,
            periodTo,
            status,
            availableStatuses,
            dataArr:dataArrInc=[], //сырой формат массива данных

         } = item
        
        const dataArrHint=dataArrInc?.map?.(({workType:{value=''}={}}={})=>value)?.join?.('; ')
        return {
            id:id?.value,
            number:number?.value, 
            date:date?.value,
            company:company?.value,
            project:project?.value,
            periodFrom:periodFrom?.value,
            periodTo:periodTo?.value,
            status:status?.rawValue,
            availableStatuses:availableStatuses?.rawValue,
            dataArrLength:dataArrInc?.length,
            dataArrHint
        }
    })

    useEffect(() => {
        // if (dirname && rightCheker(dirname, 'view')) {
            getDocumentData({
                docId: "planSchedule"
            })
            return () => {
                if (documentData?.abort) documentData.abort();
                setDocumentData(undefined);
            }
        // }
    }, [])

    // const dirLabel = list.find(({ id }) => id === dirname)
    if(!rights?.['plan-view']) return null;
    return (
        <ContentContainer
            content={documentData?.loading?(
                <SaveStatus dataObj={documentData} />
            ):(
                <DocumentSheduleBody documents={mapedDocuments} rights={rights} />
            )
           }
        />

    )
}

export default DocumentShedule
